var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block-discussion"
    },
    [
      _c(
        "courseware-collapsible-box",
        {
          attrs: {
            title: _vm.text.comments,
            open: _vm.hasComments
          }
        },
        [
          _c("courseware-block-comments", {
            attrs: {
              block: _vm.block
            },
            on: {
              hasComments: function hasComments($event) {
                _vm.hasComments = true
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.canEdit || _vm.userIsTeacher
        ? _c(
            "courseware-collapsible-box",
            {
              attrs: {
                title: _vm.text.feedback,
                open: _vm.hasFeedback
              }
            },
            [
              _c("courseware-block-feedback", {
                attrs: {
                  block: _vm.block,
                  canEdit: _vm.canEdit
                },
                on: {
                  hasFeedback: function hasFeedback($event) {
                    _vm.hasFeedback = true
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }